import React from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import styled from 'styled-components';
import { colors, theme } from 'theme';
import { useSelector } from 'react-redux';

const Wrapper = styled.div`
	cursor: pointer;
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 24px;
	padding: ${theme.padding.sm};
	padding-left: ${theme.padding.md};
	padding-right: ${theme.padding.md};
	margin: ${theme.margin.smmd};
	margin-left: ${({ isMobile }) => (isMobile ? '0px' : theme.margin.smmd)};
	margin-right: ${({ isMobile }) => (isMobile ? '0px' : theme.margin.smmd)};
	font-size: ${({ isMobile }) =>
		isMobile ? theme.fontSizes.sm : theme.fontSizes.md};
	border-radius: ${theme.borderRadius.xllg};
	border-width: 1px;
	border-style: solid;
	border-color: ${(props) =>
		props.isOpen ? colors.primary.first : colors.outlines.outline};
	background-color: ${(props) =>
		props.isOpen ? colors.surfaces.alternate : 'white'};
	color: ${(props) => (props.isOpen ? colors.primary.first : 'auto')};
`;

export function DropdownButton({
	isOpen,
	showTriangle,
	children,
	onClick = () => {},
	className,
}) {
	const isMobile = useSelector((state) => state.ui.isMobile);
	return (
		<Wrapper
			isMobile={isMobile}
			isOpen={isOpen}
			className={className}
			onClick={onClick}
		>
			{children}
			{showTriangle && <DropdownTriangle isOpen={isOpen} />}
		</Wrapper>
	);
}

const StyledFaCaretUp = styled(FaCaretUp)`
	color: rgb(114, 42, 133);
	font-size: 16px;
`;

const StyledFaCaretDown = styled(FaCaretDown)`
	color: rgb(114, 42, 133);
	font-size: 16px;
`;

const TriangleWrapper = styled.div`
	width: 25px;
	display: flex;
	align-items: center;
	margin-right: 10px;
	margin-left: auto;
`;

export function DropdownTriangle({ isOpen, style, className }) {
	return (
		<TriangleWrapper style={style} className={className}>
			{isOpen && <StyledFaCaretUp />}
			{!isOpen && <StyledFaCaretDown />}
		</TriangleWrapper>
	);
}
